
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/[bookId]",
      function () {
        return require("private-next-pages/books/[bookId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/[bookId]"])
      });
    }
  